import { render, staticRenderFns } from "./CreateOrderList.vue?vue&type=template&id=6fc8f0d2"
import script from "./CreateOrderList.vue?vue&type=script&lang=js"
export * from "./CreateOrderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports